export default class Modal {
    constructor() {
        this.scrollLockTokens = new WeakMap();
        this.imageClearTimers = new WeakMap();
        this.lockedScrollY = null;
        this.init();
    }

    init() {
        this.eventBind();
    }

    resetEvent() {
        this.eventBind("reset");
    }

    eventBind(resetOption) {
        const openbuttons = [...document.querySelectorAll(".js-modal_open")];
        const closebuttons = [...document.querySelectorAll(".js-modal_close")];
        const modals = [...document.querySelectorAll(".js-modal")];

        const handleOpen = (e) => {
            e.preventDefault();
            const modalID = e.currentTarget.getAttribute("data-modalID");
            const tgtmodal = document.querySelector(`.js-modal[data-modalID=${modalID}]`);
            if (!tgtmodal) return;

            //最初のモーダルを開く直前の位置に背景を固定する
            if (!document.querySelector(".js-modal.-active")) {
                this.lockPageScroll();
            }

            tgtmodal.classList.add("-active");

            if (window.scrollFunc && !this.scrollLockTokens.has(tgtmodal)) {
                const token = window.scrollFunc.acquireScrollLock(`modal:${modalID}`);
                this.scrollLockTokens.set(tgtmodal, token);
            }

            if (modalID === "image" && e.currentTarget.getAttribute("data-kvSrc")) {
                const tgtImg = tgtmodal.querySelector("img");
                const imgPath = e.currentTarget.getAttribute("data-kvSrc");
                if (tgtImg && imgPath) tgtImg.src = imgPath;
                const tgtTtl = tgtmodal.querySelector(".js-modal_ttl");
                const ttl = e.currentTarget.getAttribute("data-kvTtl");
                if (tgtTtl) tgtTtl.textContent = ttl ? `【${ttl}】` : "";
                return;
            }
            if (modalID === "image") {
                const tgtImg = tgtmodal.querySelector("img");
                const btnImg = e.currentTarget.querySelector("img");
                if (tgtImg && btnImg) tgtImg.src = btnImg.src;
                return;
            }
        };

        const handleClose = (e) => {
            const tgtmodal = e.currentTarget.closest(".js-modal");
            if (!tgtmodal) return;

            tgtmodal.classList.remove("-active");

            if (tgtmodal.getAttribute("data-modalID") === "image") {
                this.clearModalImage(tgtmodal);
            }

            //別のモーダルが開いている場合はページロックを維持
            if (!document.querySelector(".js-modal.-active")) {
                this.unlockPageScroll();
            }

            const token = this.scrollLockTokens.get(tgtmodal);
            if (window.scrollFunc && token) {
                window.scrollFunc.releaseScrollLock(token);
                this.scrollLockTokens.delete(tgtmodal);
            }
        };

        //モーダル内コンテンツ以外をクリックしたらクローズ処理
        const handleBgClick = (e) => {
            if (e.target.closest(".js-modal_content, .js-modal_close")) return;
            const closeBtn = e.currentTarget.closest(".js-modal").querySelector(".js-modal_close");
            closeBtn && closeBtn.click();
        };

        //モーダルがスクロールできる方向だけ許可し、端から背景への伝播を止める
        const handleModalWheel = (e) => {
            const modal = e.currentTarget;
            const maxScrollTop = modal.scrollHeight - modal.clientHeight;
            const isAtTop = modal.scrollTop <= 0;
            const isAtBottom = modal.scrollTop >= maxScrollTop - 1;

            if (
                maxScrollTop <= 0 ||
                (e.deltaY < 0 && isAtTop) ||
                (e.deltaY > 0 && isAtBottom)
            ) {
                e.preventDefault();
            }

            e.stopPropagation();
        };

        openbuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleOpen);
            el.addEventListener("click", handleOpen);
        });

        closebuttons.forEach((el) => {
            resetOption && el.removeEventListener("click", handleClose);
            el.addEventListener("click", handleClose);
        });

        modals.forEach((el) => {
            resetOption && el.removeEventListener("click", handleBgClick);
            el.addEventListener("click", handleBgClick);

            resetOption && el.removeEventListener("wheel", handleModalWheel);
            el.addEventListener("wheel", handleModalWheel, { passive: false });
        });
    }

    clearModalImage(modal) {
        const tgtImg = modal.querySelector("img");
        if (!tgtImg) return;

        const runningTimer = this.imageClearTimers.get(modal);
        if (runningTimer) clearTimeout(runningTimer);

        const timer = setTimeout(() => {
            this.imageClearTimers.delete(modal);
            if (modal.classList.contains("-active")) return;
            tgtImg.removeAttribute("src");
            const tgtTtl = modal.querySelector(".js-modal_ttl");
            if (tgtTtl) tgtTtl.textContent = "";
        }, 500);

        this.imageClearTimers.set(modal, timer);
    }

    lockPageScroll() {
        const root = document.documentElement;
        this.lockedScrollY = window.scrollY;

        //スクロールバーが消える分を補い、背景の横ずれも防ぐ
        const scrollbarWidth = window.innerWidth - root.clientWidth;
        root.style.setProperty("--modal-scrollbar-width", `${scrollbarWidth}px`);
        root.style.setProperty("--modal-scroll-y", `${this.lockedScrollY}px`);

        root.classList.add("-lock");
        document.body.classList.add("-lock");
    }

    unlockPageScroll() {
        const root = document.documentElement;
        const scrollY = this.lockedScrollY === null ? window.scrollY : this.lockedScrollY;

        root.classList.remove("-lock");
        document.body.classList.remove("-lock");
        root.style.removeProperty("--modal-scrollbar-width");
        root.style.removeProperty("--modal-scroll-y");

        //モーダル中に外部処理で位置が変わっても、開く直前の位置へ確実に戻す
        if (window.lenis) {
            window.lenis.scrollTo(scrollY, {
                immediate: true,
                force: true,
            });
        } else {
            window.scrollTo(0, scrollY);
        }

        this.lockedScrollY = null;
    }
}
